import React from 'react';

import "../assets/Home.css";
import vedit from "../assets/vedit.jpg";
import arrow from "../assets/arrow2.svg";

const Section2 = () => {
  return (
    <div className="section">
        <p className="sec2Text">web developer<br />data analyst<br />ui/ux designer<br />photographer<br /> graphic designer</p>
        <img className='vedit' src={vedit} alt='arrow' />
        <p className='about'>I am a fourth-year engineering student pursuing a Bachelor of Technology in Information Technology at Dwarkadas Jivanlal Sanghvi College of Engineering. With strong creative and visualization skills, I excel in web development, visualizing data and have a keen eye for detail. As a team player, I actively contribute to projects and strive for excellence.</p>
        <img className='arrow2' src={arrow} alt='arrow' />

    </div>
  );
};

export default Section2;
